export default __webpack_public_path__ + "static/media/footer-icon-1.e1f6845f.svg";